import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import Dash from '../views/dash.vue'
import AdminMunicipios from '../views/admin/municipios.vue'
import AdminPaquetes from '../views/admin/paquetes.vue'
import AdminUsuarios from '../views/admin/usuarios.vue'

import AdminHome from '../views/admin/home.vue'
import AdminPagos from '../views/admin/pagos.vue'

import MunDepartamentos from '../views/mun/general/departamentos.vue'
import MunInformes from '../views/mun/general/informes.vue'
import MunSecretarias from '../views/mun/general/secretarias.vue'
import MunUsuariosM from '../views/mun/general/usuarios_municipio.vue'
import DashPrincipal from '../views/mun/general/dashPrincipal.vue'


import pathsecretaria from '../views/mun/general/secretarias/home.vue'
import departamentos_secretaria from '../views/mun/general/secretarias/departamentos.vue'
import pathMesFrec from '../views/mun/general/indicadores/indicadores_frecuencias/home.vue'

import imprimirObjetivo from '../views/mun/poas/imprimir_objetivo.vue'
import imprimirProblem from '../views/mun/poas/imprimir_Problema.vue'

import Poas from '../views/mun/poas/poas.vue'
import pathpoa from '../views/mun/poas/home.vue'
import pathpoal from '../views/mun/poas/home1.vue'
import poa_lineas from '../views/mun/poas/poa_linea_accion.vue'
import poa_actividades from '../views/mun/poas/poa_actividades_linea_accion.vue'

import ImprimirPoas from '../views/mun/poas/imprimir_poa.vue'


import mes_frecuencia from '../views/mun/general/indicadores/indicadores_frecuencias/indicadores_mesesXfrecuencia.vue'

/**poas municipios*/


import PmdUsuarios from '../views/mun/general/pmd/pmd_usuarios.vue'

import PmdArbol from '../views/mun/general/pmd/pmdArbol.vue'



//REPORTES
import Rep_detalle_fisico from '../views/mun/reportes/detalle_fisico.vue'
import Rep_estadistico_fisico from '../views/mun/reportes/estadistico_fisico.vue'
import Rep_estadistico_pps from '../views/mun/reportes/estadistico_pps.vue'
import indicadores_variables from '../views/mun/reportes/indicadores_variables.vue'
import Rep_pmd_importes from '../views/mun/reportes/pmd_importes.vue'
import Rep_rep_excel from '../views/mun/reportes/rep_excel.vue'
import Rep_rep_trimestre from '../views/mun/reportes/rep_trimestre.vue'
import Rep_validar_avance_fisico from '../views/mun/reportes/validar_avance_fisico.vue'
import Rep_valores_variables from '../views/mun/reportes/valores_variables.vue'
import Rep_validar_importe_pps from '../views/mun/reportes/validar_importe_pps.vue'

//INDICADORES
import Indicadores_Series from '../views/mun/general/indicadores/indicadores_series.vue'
import Indicadores_Desempeno from '../views/mun/general/indicadores/indicadores_desempeno_enlaces.vue'
import Indicadores_Adminis from '../views/mun/general/indicadores/indicadores_administradores.vue'
import Indicadores_FormAdminis from  '../views/mun/general/indicadores/form_indicadores_administradores.vue'

import Imprimir_Indicador from  '../views/mun/general/indicadores/imprimir_indicador.vue'
import Imprimir_IndicadorMir from  '../views/mun/general/indicadores/imprimir_indicadormir.vue'
import Indicadores_ValorVariable from  '../views/mun/general/indicadores/indicadores_valores_variables.vue'
import Indicadores_Formula from  '../views/mun/general/indicadores/indicadores_formulas.vue'
//INDICADORES CATALOGOS
import Indicadores_Frec from '../views/mun/general/indicadores/indicadores_frecuencias.vue'

import Indicadores_Clasif from '../views/mun/general/indicadores/catalogos/indicadores_clasificaciones.vue'

import Indicadores_MesFrec from '../views/mun/general/indicadores/indicadores_mesesXfrecuencia.vue'

import Indicadores_Areas from '../views/mun/general/indicadores/catalogos/indicadores_areas.vue'
import pathArea from '../views/mun/general/indicadores/catalogos/home.vue'
import Indicadores_Area_Dim from '../views/mun/general/indicadores/catalogos/indicadores_dimensiones.vue'

//import Indicadores_Dim from '../views/mun/general/indicadores/catalogos/indicadores_dimensiones.vue'

//INDICADORES VISTAS
import Indicadores_UniMed from '../views/mun/general/indicadores/variables/indicadores_unidad_medidas.vue'
import Indicadores_Fuentes from '../views/mun/general/indicadores/variables/indicadores_fuentes_informacion.vue'
import Indicadores_variables from '../views/mun/general/indicadores/variables/indicadoresvariables.vue'



//POAS


import PoaClasifProgra from  '../views/mun/poas/conac/poa_programaticas.vue'
import PoaCapCONAC from  '../views/mun/poas/conac/poa_capitulos_conac.vue'
import PoaClasiFuncionales from  '../views/mun/poas/conac/poa_clasif_funcionales.vue'

import Pmd from '../views/mun/general/Pmd.vue'
import pathpmd from '../views/mun/general/pmd/home.vue'
import Pmdejes from '../views/mun/general/pmd/ejes.vue'
import Pmdestrategias from '../views/mun/general/pmd/estrategias.vue'
import Pmdobjetivos from '../views/mun/general/pmd/objetivos.vue'
import PmdlineasAccion from '../views/mun/general/pmd/lineasdeaccion.vue'


import PoaFinalidades from  '../views/mun/poas/conac/poa_finalidades.vue'
//import PoaFunciones from '../views/mun/poas/conac/poa_funciones.vue'
import pathFun from '../views/mun/poas/conac/home.vue'
import  fin_fun from '../views/mun/poas/conac/poa_funciones.vue'
import fun_sub from '../views/mun/poas/conac/poa_subfunciones.vue'


import PoaGobierno from  '../views/mun/poas/conac/poa_gobierno.vue'
//import PoaFunciones from '../views/mun/poas/conac/poa_funciones.vue'
import pathG from '../views/mun/poas/conac/home.vue'
import  gob_social from '../views/mun/poas/conac/poa_Sociales.vue'
import soc_economico from '../views/mun/poas/conac/poa_Economico.vue'


//import PoaSubFunciones from  '../views/mun/poas/conac/poa_subfunciones.vue'
import PoaSeries from  '../views/mun/poas/series.vue'
import PoaTechosDep from  '../views/mun/poas/techos_capitulos_dep.vue'
import PoaTechos from  '../views/mun/poas/techos_secretarias_serie.vue'
import PoaTechosReport from  '../views/mun/poas/techos_report.vue'
import ReporteFinanciero from  '../views/mun/reportes/rep_trimestreFinanciero.vue'


//import PoaLinea from  '../views/mun/poas/poa_linea_accion.vue'
/**--- */
import poasMenu from '../views/mun/poas/poasmenu.vue'
import poasBuilder from '../views/mun/poas/problembuilder.vue'
import ObjetivosBuilder from '../views/mun/poas/objetivosbuilder.vue'
import MirBuilder from '../views/mun/poas/mirbuilder.vue'
import MirBuilderv1 from '../views/mun/poas/mirbuilderv1.vue'
import defaultt from '../views/mun/poas/default.vue'
import PdfArboles from '../views/mun/poas/viewerpdfArboles.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
 
  {
    path: '/su',
    name: 'dash',
    component: Dash,
    children: [
      {
         path: '/',
         name: 'municipios',
         component: AdminHome,
         
       },
       {
        path: 'municipios',
        name: 'municipioss',
        component: AdminMunicipios,
        
      },
       {
        path: 'usuarios',
        name: 'usuarios',
        component: AdminUsuarios,
        
      },   
       {
        path: 'paquetes',
        name: 'paquetes',
        component: AdminPaquetes,
        
      },
      {
        path: 'pagos',
        name: 'pagos',
        component: AdminPagos,
        
      }
    ]

  },
    {
    path: '/mun',
    name: 'dashmun',
    component: Dash,
    children: [
      {
        path: 'reportes/detallefisico',
        name: 'detalle_fisico',
        component: Rep_detalle_fisico,
        
      },
      {
        path: 'reportes/estadisticofisico',
        name: 'estadistico_fisico',
        component: Rep_estadistico_fisico,
        
      },
      {
        path: 'reportes/estadisticopps',
        name: 'estadistico_pps',
        component: Rep_estadistico_pps,
        
      },
      {
        path: 'reportes/indicadoresvariables',
        name: 'indicadores_variables',
        component: indicadores_variables,
        
      },
      {
        path: 'reportes/pmdimportes',
        name: 'pmd_importes',
        component: Rep_pmd_importes,
        
      },
      {
        path: 'reportes/repexcel',
        name: 'rep_excel',
        component: Rep_rep_excel,
        
      },
      {
        path: 'reportes/reptrimestre',
        name: 'rep_trimestre',
        component: Rep_rep_trimestre,
        
      },
      {
         path: 'reportes/financiero',
        name: 'rep_financiero',
        component: ReporteFinanciero,
        
      },
      {
        path: 'reportes/validavancefisico',
        name: 'validar_avance_fisico',
        component: Rep_validar_avance_fisico,
        
      },
      {
        path: 'reportes/valoresvariables',
        name: 'valores_variables',
        component: Rep_valores_variables,
        
      },
      {
        path: 'reportes/importe_pps',
        name: 'validar_importe_pps',
        component: Rep_validar_importe_pps,
        
      },


      {
        path: '/mun/poa/arbol',
        name: 'pmdArbol',
        component: PmdArbol,
        
      },
       {
        path: 'poa/builder',
        name: 'poas/builder',
        component: poasBuilder,
        
        
      },
       {
        path: 'pmd/objetivosbuilder',
        name: 'pmd/objetivosbuilder',
        component: ObjetivosBuilder,
        
        
      },
       {
    path: 'pmd/viewerPdfArboles',
    name: 'pdfarboles',
    component: PdfArboles
  },
  
      
       {
        path: 'pmd/mirbuilder',
        name: 'pmd/mirbuilder',
        component:MirBuilder,
        
        
      },
        {
        path: 'pmd/mirbuilderv1',
        name: 'pmd/mirbuilderv1',
        component:MirBuilderv1,
          children: [
             {
        path: '',
        name: 'defaultmir',
        component: defaultt,
        
      },
      {
        path: 'indicador',
        name: 'Indicadores_FormAdminis',
        component: Indicadores_FormAdminis,
        
      }]
        
      },
      {
        path: 'poas/conac/gobierno',
        name: 'poa_Gobierno',
        component: PoaGobierno,
        children:[
          {
            path: '',
            name: 'pathG',
            component: pathG,
            
          },


          
      {
        path: 'sociales',
        name: 'poa_Sociales',
        component: gob_social,
        children:[


          {
            path: '',
            name: 'pathG',
            component: pathG,
            
          },
            {
              path: 'economico',
              name: 'poa_Economico',
              component: soc_economico,
              
            },
    
    
          ]
        
        
      },]
        
    },

      {
        path: 'poas/conac/finalidades',
        name: 'poa_finalidades',
        component: PoaFinalidades,
        children:[
          {
            path: '',
            name: 'pathFin',
            component: pathFun,
            
          },


          
      {
        path: 'funciones',
        name: 'poa_funciones',
        component: fin_fun,
        children:[


          {
            path: '',
            name: 'pathFun',
            component: pathFun,
            
          },
            {
              path: 'subfunciones',
              name: 'poa_subfunciones',
              component: fun_sub,
              
            },
    
    
          ]
        
        
      },]
        
    },
     /* {
        path: 'poa/conac/subfunciones',
        name: 'poa_subfunciones',
        component: PoaSubFunciones,
        
        
      },*/
      {
        path: 'poa/conac/tipodegastos',
        name: 'poa_programaticas',
        component: PoaClasifProgra,
        
        
      },
      {
        path: 'poa/imprimirObje',
        name: 'imprimir_objetivo',
        component: imprimirObjetivo,
        
        
      },
      {
        path: 'poa/imprimirProblem',
        name: 'imprimir_Problema',
        component: imprimirProblem,
        
        
      },
      {
        path: 'poa/conac/otrotipodegastos',
        name: 'poa_clasif_funcionales',
        component: PoaClasiFuncionales,
        
        
      },
      {
        path: 'poa/conac/capconac',
        name: 'poa_capitulos_conac',
        component: PoaCapCONAC,
        
        
      },
     
      
      /*{
        path: 'poa/linea',
        name: 'poa_linea_accion',
        component: PoaLinea,
        
        
      },*/
     
      {
        path: 'poa/techos_report',
        name: 'pos_techos_report',
        component: PoaTechosReport,
        
        
      },
        {
        path: 'poa/techos',
        name: 'pos_techos',
        component: PoaTechos,
        
        
      },
      {
        path: 'poa/techos_depa',
        name: 'pos_techos_depa',
        component: PoaTechosDep,
        
        
      },    
      
       {
        path: 'general/departamentos',
        name: 'departamentos',
        component: MunDepartamentos,
        
      },
       {
        path: 'general/informesresultado',
        name: 'informes',
        component: MunInformes,
        
      },
      {
      path: 'general/indicadores/catalogos/areas',
      name: 'indicadores_areas',
      component: Indicadores_Areas,
      children:[


        {
          path: '',
          name: 'pathArea',
          component: pathArea,
          
        },
          {
            path: 'dimensiones',
            name: 'indicadores_dimensiones',
            component: Indicadores_Area_Dim,
            
          },
  
  
        ]
      
    },
    {
      path: 'general/indicadores/desempenoEnlaces',
      name: 'indicadores_desempeno_enlaces',
      component: Indicadores_Desempeno,
      
    },
    {
      path: 'general/indicadores/capVariable',
      name: 'indicadores_valores_variables',
      component: Indicadores_ValorVariable,
      
    },
    {
      path: 'general/indicadores/administradores',
      name: 'indicadores_administradores',
      component: Indicadores_Adminis,
      
    },
    {
      path: 'general/indicadores/imprimirindicador',
      name: 'imprimir_indicadormir',
      component: Imprimir_IndicadorMir,
      
    },
    {
      path: 'general/indicadores/imprimirindicador1',
      name: 'imprimir_indicador',
      component: Imprimir_Indicador,
      
    },
    {
      path: 'general/indicadores/formula',
      name: 'indicadores_formulas',
      component: Indicadores_Formula,
      
    },
    {
      path: 'general/indicadores/formAdministradores',
      name: 'form_indicadores_administradores',
      component: Indicadores_FormAdminis,
      
    },
    {
      path: 'general/indicadores/series',
      name: 'indicadores_series',
      component: Indicadores_Series,
      
    },

    {
      path: 'general/indicadores/variables/unidadmedidas',
      name: 'indicadores_unidad_medidas',
      component: Indicadores_UniMed,
      
    },
    {
      path: 'general/indicadores/variables/fuentes',
      name: 'indicadores_fuentes_informacion',
      component: Indicadores_Fuentes,
      
    },
    {
      path: 'general/indicadores/variables/variables',
      name: 'indicadores_variables',
      component: Indicadores_variables,
      
    },
    {
      path: 'general/indicadores/catalogos/clasificaciones',
      name: 'indicadores_clasificaciones',
      component: Indicadores_Clasif,
      
    },
   /* {
      path: 'general/indicadores/catalogos/dimensiones',
      name: 'indicadores_dimensiones',
      component: Indicadores_Dim,
      
    },*/
    {
      path: 'general/series',
      name: 'poa_series',
      component: PoaSeries,
      
      
    },
    {
      path: 'general/usuariosmunicipio',
      name: 'usuarios_municipio',
      component: MunUsuariosM,
      
    },
  
        {
      path: 'general/indicadores/frecuencias',
      name: 'indicadores_frecuencias',
      component: Indicadores_Frec,
     children:[


      {
        path: '',
        name: 'pathM',
        component: pathsecretaria,
        
      },
        {
          path: 'meses',
          name: 'indicadores_mesesXfrecuencia',
          component: Indicadores_MesFrec,
          
        },


      ]
    
    },
   
       {
        path: 'poa/poas',
        name: 'poas', 
        component: Poas,
         children: [
      
       {
        path: '',
        name: 'pathP',
        component: pathpoa,
        
      },
      {
        path: 'imprimirpoa',
        name: 'imprimir_poa',
        component: ImprimirPoas,
        
        
      },
       {
        path: 'lineas',
        name: 'poa_linea_accion',
        component: poa_lineas,
        children: [
      
          {
           path: '',
           name: 'pathPL',
           component: pathpoal,
           
         },
         {
           path: 'actividadlineas',
           name: 'poa_actividades_linea_accion',
           component: poa_actividades,
           
         },
         ]
      },
      ]
        
      },


      {
        path: 'general/dash',
        name: 'dashPrincipal',
        component: DashPrincipal,},
      {
        path: 'general/secretarias',
        name: 'secretarias',
        component: MunSecretarias,
         children: [
      
       {
        path: '',
        name: 'pathd',
        component: pathsecretaria,
        
      },
       {
        path: 'departamentos',
        name: 'departamentos_secretaria',
        component: departamentos_secretaria,
        
      },
      ]
        
      },
      //-----poa
{
  
        path: 'general/pmd',
        name: 'pmd',
        component: Pmd,
         children: [
      
       {
        path: '',
        name: 'pathpmd',
        component: pathpmd,
        
      },
       {
        path: 'ejes',
        name: 'ejes',
        component: Pmdejes,
         children: [
      
       {
        path: '',
        name: 'pathpmd',
        component: pathpmd,
        
      },
       {
        path: 'estrategias',
        name: 'estrategias',
        component: Pmdestrategias,
          children: [
      
       {
        path: '',
        name: 'pathpmd',
        component: pathpmd,
        
      },
       {
        path: 'lineasaccion',
        name: 'lineasaccion',
        component: PmdlineasAccion,
        
      }]
        
      }]
        
      },
      /*  {
        path: 'ejes',
        name: 'ejes',
        component: Pmdejes,
         children: [
      
       {
        path: '',
        name: 'pathpmd',
        component: pathpmd,
        
      },
       {
        path: 'objetivos',
        name: 'objetivos',
        component: Pmdobjetivos,
         children: [
      
       {
        path: '',
        name: 'pathpmd',
        component: pathpmd,
        
      },
       {
        path: 'estrategias',
        name: 'estrategias',
        component: Pmdestrategias,
          children: [
      
       {
        path: '',
        name: 'pathpmd',
        component: pathpmd,
        
      },
       {
        path: 'lineasaccion',
        name: 'lineasaccion',
        component: PmdlineasAccion,
        
      }]
        
      }]
        
      }]
        
      }, */
      
     
      {
        path: 'pmd_usuarios',
        name: 'pmd_usuarios',
        component: PmdUsuarios,
        
      }
     

      
    ]
        
      }
      //-------end poa
      ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
